import React, { memo } from 'react';

import { classNameBind } from '@wconcept/wconcept-common/utils/commonUtils';

import * as S from './style';

interface IProps {
  /** className */
  className?: string;
  /** 퀵메뉴 버튼 목록 */
  items?: React.ReactNode;
  /** isDesktop */
  isDesktop?: boolean;
  /** MO에서 1행으로 노출할 최대 개수(초과 시 2행으로 분할) */
  oneRowMax?: number;
}

const QuickMenuBarType2 = ({
  className,
  items,
  isDesktop = false,
  oneRowMax = 5,
}: IProps): React.ReactElement => {
  const cName = classNameBind(['quickmenu-list-type2', className || '']);
  const itemList = React.Children.toArray(items);

  // MO는 개수가 oneRowMax를 넘으면 2행으로 나눠 배치(앞 절반이 윗줄)
  const rows =
    itemList.length > oneRowMax
      ? [
          itemList.slice(0, Math.ceil(itemList.length / 2)),
          itemList.slice(Math.ceil(itemList.length / 2)),
        ]
      : [itemList];

  return (
    <S.QuickMenuBarType2 className={cName}>
      {isDesktop
        ? itemList
        : rows.map((row, i) => (
            // eslint-disable-next-line react/no-array-index-key
            <div className="quickmenu-row" key={i}>
              {row}
            </div>
          ))}
    </S.QuickMenuBarType2>
  );
};

export default memo(QuickMenuBarType2);
